/**
 * @param {number} length
 * @return {Array}
 */
var range = function range(length) {
  return Array.apply(null, {
    length: length
  });
};

export default range;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/range.js
// module id = oOd2
// module chunks = 1